import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { QRCodeSVG } from 'qrcode.react';
import { useAuth } from '../contexts/AuthContext';
import { useBusiness } from '../contexts/BusinessContext';
import { QrCode } from 'lucide-react';

const UserCodePage: React.FC = () => {
  const { currentUser } = useAuth();
  const { currentBusiness } = useBusiness();

  // Generar un código único basado en el ID del usuario y el negocio
  const uniqueCode = useMemo(() => {
    if (!currentUser?.uid) return '';
    const businessPart = currentBusiness?.id || 'default';
    return `DOJO:${businessPart}:${currentUser.uid}`;
  }, [currentUser?.uid, currentBusiness?.id]);

  if (!currentUser) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-400">Cargando...</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Mi Código</title>
      </Helmet>

      <div className="min-h-[calc(100vh-8rem)] flex flex-col items-center justify-center px-4">
        {/* Contenedor principal */}
        <div className="w-full max-w-md mx-auto text-center">
          {/* Título */}
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-500/20 mb-4">
              <QrCode className="w-8 h-8 text-amber-400" />
            </div>
            <h1 className="text-2xl font-bold text-amber-400">
              Mi Código Personal
            </h1>
            <p className="text-gray-400 mt-2">
              Muestra este código para identificarte
            </p>
          </div>

          {/* QR Code grande */}
          <div className="bg-gray-900 rounded-3xl shadow-2xl p-8 mx-auto border border-gray-800">
            <div className="bg-white p-6 rounded-2xl inline-block">
              <QRCodeSVG
                value={uniqueCode}
                size={280}
                level="H"
                includeMargin={false}
                bgColor="#ffffff"
                fgColor="#000000"
              />
            </div>
            
            {/* Nombre del usuario */}
            <div className="mt-6 pt-6 border-t border-gray-700">
              <p className="text-xl font-semibold text-white">
                {currentUser.firstName} {currentUser.lastName}
              </p>
              {currentBusiness && (
                <p className="text-sm text-gray-400 mt-1">
                  {currentBusiness.name}
                </p>
              )}
            </div>
          </div>

          {/* Instrucciones */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Este código es único y personal.
            </p>
            <p className="text-sm text-gray-500 mt-1">
              Úsalo para registrar asistencia y acceder a servicios.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserCodePage;
